import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "@assets/css/index.css";
import "@assets/css/forms.css";
import "@assets/css/custom-scroll.css";
import "@assets/css/tables.css";
import "@assets/css/pages/languages.css";
import App from "@src/App";
import reportWebVitals from "@src/reportWebVitals";
import store from "@store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
